import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { apiRequest } from "../../apiServices/allApi";

export default function Cancelled() {
  const id = localStorage.getItem("id");

  const [challenge, setchallenge] = useState([]);
  const [selectedType, setSelectedType] = useState("");

  // pagination
  let [limit, setLimit] = useState(20);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
  };

  const fetchData = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/challange/cancelled?page=${pageNumber}&_limit=${limit}`,
        "GET",
        null,
        headers,
      );
      setchallenge(res?.data?.data || []);
      setNumberOfPages(res.data?.totalPages || 0);
    } catch (error) {
      console.error("Error fetching cancelled challenges:", error);
    }
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    return date.toLocaleString("default", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
  };

  useEffect(() => {
    fetchData();
  }, [pageNumber, limit, selectedType]);

  return (
    <div className="row mt-4">
      <div className="col-12 grid-margin">
        <div className="card">
          <div className="card-body p-2">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
              <h4 className="dashboard_heading m-0 text-danger">
                <i className="mdi mdi-close-circle text-danger mr-2"></i>{" "}
                Cancelled Challenges
              </h4>
              <div className="d-flex flex-wrap align-items-center mt-2 mt-md-0">
               
                <select
                  className="form-control"
                  style={{ width: "110px" }}
                  id="pagelimit"
                  name="pagelimit"
                  value={limit}
                  onChange={setpageLimit}
                >
                  <option value="10">10 / page</option>
                  <option value="20">20 / page</option>
                  <option value="50">50 / page</option>
                  <option value="100">100 / page</option>
                  <option value="500">500 / page</option>
                </select>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    {id === "67f8f9731bb8e80965dd62b8" && <th>ID</th>}
                    <th>Creator</th>
                    <th>Accepter</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Game Type</th>
                    <th>Date</th>
                    <th className="text-right pr-4">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {challenge && challenge.length > 0 ? (
                    challenge.map((game, key) => (
                      <tr key={game._id || key}>
                        <td>{key + 1}</td>
                        {id === "67f8f9731bb8e80965dd62b8" && (
                          <td>
                            <code>{game._id?.substring(0, 8)}...</code>
                          </td>
                        )}
                        <td>
                          <strong>{game.Created_by?.Name || "N/A"}</strong>
                        </td>
                        <td>
                          <strong>{game.Accepetd_By?.Name || "N/A"}</strong>
                        </td>
                        <td>
                          <span className="text-danger font-weight-bold">
                            ₹{game.Game_Ammount}
                          </span>
                        </td>
                        <td>
                          <span className="badge badge-danger">Cancelled</span>
                        </td>
                        <td>
                          <span className="badge">
                            {game.Game_type}
                          </span>
                        </td>
                        <td className="text-muted small">
                          {dateFormat(game.createdAt)}
                        </td>
                        <td className="text-right pr-4">
                          <Link
                            className="btn btn-sm btn-outline-primary"
                            to={`/view/${game._id}`}
                          >
                            <i className="mdi mdi-eye mr-1"></i> View
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center py-4 text-muted">
                        No cancelled challenges found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="mt-4">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={numberOfPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
